var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { providers, provider } from 'helpers/Providers';
import { mergeDeep } from 'helpers/Utils';
var common = {
    size: {
        font: 14,
        lineHeight: 1.2,
        space: 8,
        hairline: 1,
        bar: 44,
        icon: 24,
        maxWidth: 900
    },
    devices: {
        mobileWidth: 414,
        mobileHeight: 667,
        desktopWidth: 720 // 40em
    }
};
var themes = (_a = {
        main: {
            fontSize: {
                small: Math.round(common.size.font * 0.85) + 'px',
                regular: common.size.font + 'px',
                big: Math.round(common.size.font * 1.15) + 'px'
            },
            color: {
                civitrip: {
                    primary: '#263A8D'
                },
                primary: '#C21942',
                // secondary: '#6E6D6E', // Dove Gray
                secondary: '#2F2F2F',
                // placeholder: '#A19FA1', // Star Dust
                placeholder: '#6E6D6E',
                rowBackground: '#FAFAFA',
                // hairline: '#E5E6E5', // Mercury
                hairline: '#A19FA1',
                backdrop: 'rgba(0,0,0,0.2)',
                backgreen: '#eaffdd',
                backred: 'rgba(255,0,0,0.2)',
                backorange: '#ffe9ce',
                backblue: '#ced5ff',
                background: '#FFFFFF',
                errorBackground: '#FFF0F0',
                errorText: '#FF0000',
                warningBackground: '#FFFBE6',
                warningText: '#5C3B00' // Saddle Brown
            },
            fontFamily: 'Lato',
            fontWeight: 300,
            lineHeight: common.size.lineHeight,
            size: {
                space: [
                    0,
                    common.size.space + 'px',
                    common.size.space * 2 + 'px',
                    common.size.space * 3 + 'px',
                    common.size.space * 4 + 'px',
                    common.size.space * 5 + 'px',
                    common.size.space * 6 + 'px',
                    common.size.space * 7 + 'px',
                    common.size.space * 8 + 'px'
                ],
                hairline: common.size.hairline + 'px',
                bar: common.size.bar + 'px',
                bottomButtons: (common.size.bar * 1.06) + 'px',
                icon: common.size.icon + 'px'
            },
            line: {
                big: Math.round(common.size.lineHeight * 1.15),
                regular: common.size.lineHeight,
                small: Math.round(common.size.lineHeight * 0.85)
            },
        }
    },
    _a[providers.redsys] = {
        color: {
            primary: '#FB6325' // Crayon Orange
        }
    },
    _a);
var border = {
    border: "".concat(themes.main.size.hairline, " solid ").concat(themes.main.color.secondary),
    borderRadius: '0.25rem',
    ':hover': {
        borderRadius: '0.30rem',
        color: themes.main.color.primary,
    }
};
mergeDeep(themes.main, themes[provider]);
export var theme = __assign(__assign({}, themes.main), { common: common, border: border });
export default theme;
export var hairline = {
    all: {
        borderWidth: theme.size.hairline,
        borderColor: theme.color.hairline
    },
    allMargingBlack: {
        borderWidth: theme.size.hairline,
        borderColor: 'black',
        marginTop: 100,
        marginBottom: 100,
    },
    top: {
        /*paddingLeft: 10,*/
        borderTopWidth: theme.size.hairline,
        borderTopColor: theme.color.hairline
    },
    topPadding: {
        marginTop: 10,
        marginBottom: 10,
        borderTopWidth: theme.size.hairline,
        borderTopColor: theme.color.hairline
    },
    bottomPadding: {
        marginLeft: 10,
        marginRight: 10,
        borderBottomWidth: theme.size.hairline,
        borderBottomColor: theme.color.hairline
    },
    bottom: {
        borderBottomWidth: theme.size.hairline,
        borderBottomColor: theme.color.hairline
    }
};
export var easing = {
    spring: 'cubic-bezier(0.23, 1, 0.32, 1)'
};
export var mediaQueries = {
    desktop: "@media screen and (min-width: ".concat(common.devices.desktopWidth, "px)"),
    mobile: "@media screen and (max-width: ".concat(common.devices.desktopWidth - 1, "px)\n  , (orientation: landscape)"),
};
export var logoCivitrip = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA8AAAACiCAYAAACOAqRXAAAACXBIWXMAABYlAAAWJQFJUiTwAAAgAElEQVR4nO3dO3bb2JbG8a9rOZc6qdS6GRlZlxMwagTGnUBJDDoucQRmjQCquALSPYELjaCgCaDJiMgulXbS0ghuBziUaFkPPg6wcQ7+v7W0LLto8itZhM7GPo//+Pe//y3sZzCanEs6dR/nW/9p8+eHKrY+v5e0c' +
    'J8vqjK7P+J5G/W///Xfl5IujWP4Nv/5z1/nuz54MJqcSrpqLo65eVVma+sQxxiMJpeSzoxj+JZXZbZ4/2G1wWiSSEoaS9OudVVm80P/8jCdTf1FQUhW+Xh6yN8bprNE8bx/2rB2H4+/X+Xj9YuPxKvcGOvMOIZv85///HXd5AsM09m5pOsmXyMAxbPfr/X0nrxf5eOdxw+x+WAdoKsGo8mZ6gtO4n49U13gnjT4sp/fyCNJd3r65l2r/sZed6AwOdMb2QNV7P' +
    'PgqszuXYH1sZE09u4V/g+SqeL795nv+fhE0lf/MUzcav///22xfB2wv+mBfy8R3zdHGaazzacPerrJX7hfF6oH5YWw7' +
    'VJxjrHWDb/GqeL7uu3rzf//rffjpr7YNN82v0Z704oCWI/F7rnqH27n6u4b5qP72OT7Kj0Wx7eqv1kXkooOFMV9VEi6sA7RkEQBF8DuPR5b8bvkfQ4gUCd6Gst8N+Zyg/JNgbxQPTBfUBgDjdnUF5L0Zfs/uPfjUu59uPkIvTDuZQHsBsPJ1kcMA+PP2vohMhhN7lQXZIUoiNuSK+4COGSJdYAGFNYBAKAhmwL5cVyzNRBfyI1tQh+EA4H45D4ei+NhOtvcpCrc' +
    'x2KVjzu7XPO53hTAbt3upeqB8CfTMO34qLoYu5CkwWiyVD1dMKcYbkZVZrnrxsfoZDCanO+z3rRjEusADZhbBwCAlm0G4heSNExnm5v9ueqCOJgBOBC47ZtUXyVpmM6Wcu/Hrs/YiLoA3ip6U8XR5T3GJ0mZpIxiuFE3ejZ9JCKJntZshSaxDuDZXcA3IwDAl+9u9g/T2Y3qYjinGAZat7lB9ZubsdHZ92N0BbCb3pyq3pG370Xva7aL4W+qd/gtbCNFI1fcBXBw64' +
    'AjXf+bWwcAgA764j5mrhier/Ix10vAxvP3Y2eK4WgKYHe8x5XiLT6aciHpwnWFr485VgSS4l6XmVgHOFBiHaAB' +
    'hXUAAOi4L5K+uLWK16qL4bVtJKC3tovhb6rfj4VVmJ+sXtiXwWhyORhN1pL+EsXvMT5Jmg1Gk7U7zgcHcFPKl9Y5GnLilhWEJrEO4NlDVWZ0NABgNyeq1yj+a5jO5sN0dmacB+i7C0l/DdPZepjOrobp7LTtAEEWwIPR5HQwmly5wnem+KY3WvqouhBeuK469ldYB2hQYh3gACEW7W+h+AWAw1yIQhjoio+ql2Suh+ls2mYhHFwBPBhNrlSfRZWJwrdJnyT9NRhNgl' +
    'vz2QFz6wANSqwD7GMwmpwqvl3fKYAB4DgXkhbDdDa1DgLgcZZGa4VwMAXw1lTnTPUXCu2IrXvWOLc774N1joYk1gH2lFgHaEBhHQAAInAi6aubhplYhwHwfSHc5At1vgAejCbJYDRZiKnOCEusXbrQ1gEn1gE8u6nKzHz3RACIyEfV6xGZ8QZ0Q+M3pzpbALt1vnPVm1vFNoUR8Yu1AJbCKioT6wCexfx9BQCWfhumswVrg4HO2Nycyn1Pi+5kAby1zvfCOApwqMI6Q' +
    'IMS6wC7YP0vAGBPn1SvDU6sgwB49EX1tOjE1xN2qgAejCZng9GkEOt8ETg3TfXWOkdDEusAO0qsA3i2ZPozADT' +
    'uRHXX6dI6CIBHm/fl1MeTdaYAdl3fhaTP1lkAT2Lt1oWyDjixDuDZ3DoAAPTIjCIY6Jyvw3RWHDsl2rwAdmt9c9H1RXxiLYClMIrLxDqAZzF/PwFAF1EEA93zWVJxzHp90wLYdZEWqud2o5uYcnmgqszWku6sczQksQ7wlgjX/y7d9xMAoF0UwUD3bNbrHzQj0awAHowml5L+Rxxt1HUL6wCBi7Vr1/Up0Il1AM8K6wAA0GMUwUD3nKjuBO89JjUpgN3xRjOL1wZaFms' +
    'B/HEwmpxZh3hDYh3As7l1AADouRm7QwOdc1AR3GoB7Nb7LsTxRuiJqswKSQ/WORqSWAd4Q2IdwKO7qsyYiQEA9nLOCQY650T1e3PnjbFaK4Bdt6hQXOvygF0U1gEaklgHeEmE639jnUUAAKE5EddkoIs+qu4E71QEt1IAb212FdOgFNhVrD8sE+sAr0isA3hWWAcAADz65OssUgBefZJ0vcsDGy+AXfFbiCOO0F+xFsBdXQecWAfw6KEqs1i/fwAgVF8P3X0WQKMudtmw' +
    'rtECmOIXkKoyu5e0tM7RkMQ6wAsS6wAeUfwCQDft1GkC0Lrr99bqN1YAU/wC35lbB2hIYh1gG+t/AQAt+cz' +
    'RSEAnneidcXcjBTDFL/CDwjpAQxLrAM8k1gE8K6wDAABeNbUOAOBFn4fpLH3tP3ovgLd2e6b4BRx3jM2ddY4GdG0dcGIdwKMbN30eANBNH+kCA5316jIFrwWwm36Yi+IXeEms01kT6wBbEusAHsX6/QIAMZlaBwDwoo+v7djuuwNcKK71d4BPhXWAhiTWAbbEdP2hAAaA7qMLDHTX1Ut/6K0AHowmc8U1+AS8ivg4m8Q6gCQNRpPEOoNHS6Y/A0AwLq0DAHjRyUs3qLwU' +
    'wIPR5FLShY/nAiJ3Yx2gAV1ZB5xYB/Bobh0AALCzz+8duwLAzPT5HxxdALsdn2fHPg/QE3SBm5NYB/Ao1u8TAIjVqzvOAjD1cZjOku0/+HDMs21teoUe+/nPX6diE4hdFdYBGpLIvmv52fj1fVlWZba2DgEganfyc80+l3T6wp/1cTPUS72x6+wRrvTj1zh0C+sAAfqmw96zZ+5Dqt+bZ+rnktVLbY3BjyqAVf9DfDzyOYDeqMpsPRhNlorv4pNYvnhk638L6wAAorde5' +
    'eNpky8wTGeb4jhRPfBOFHdh/GmYzs5W+Xjt80l//vNXikVI9Xu28PVk7v2ZbH3E/N6Uns3QOLgAdut+vxyb' +
    'BuihXPEVwB8Ho8mZYecyMXrdJsytAwDAsVb5eFO4FZs/c4PuS9WD0RgbKIm4hiMA7v25kJu14DaKulQ8s+meOxmms2RzE+GgAthteNPENA+gD3JJX61DNCCR3Q/+xOh1fburyoy7/e343TrAM5eKsyDwNdUWEXCD7itJV8N0lrrPYxpwJ+L7HQFa5eO5pLm7SXWtuN6XG6ncDblDO8Bzxd8qx44Go8lU8RV0v1dlNm3iiasyWwxGkwfF9x5KZPeDP5YLNXsqtKTp6Z/7c' +
    'ht0xFgANz7VFmFa5eNcUj5MZ1eq9xGJ4WfiuXUA4BjuJlXifibNFdfPpWTzyd67QA9Gk1TxDDYBKzEWOonFi7L+FwDCtcrH16p/fjwYR/EhtuVN6Ck3Vfhc0q1xFJ8+DdPZqbRnB9jt+jxvIlEPPKiea3+vp93v1u7jLWd62r1t8/mpuMiGLld8Z2d/HIwmp1WZ3bf8uknLr9eUh6rMYrwxAgBvWuXjhes4FQq8E7y9zhAI2Sof36vuBs8Vz5j1XFKx7xToqQK/MLXkQfV' +
    'FfLH5tYmiwK3FPlNdAJyp/kelMA5DYR2gIYna724nLb9eUyh+AfSWK4JTSX9ZZzlSbEcWoedW+fjSdU5j2P' +
    'w40T4FsCu2fmsqTQSWqgeweVub2Lgdd9d6Vky5KaGJ+nHsQJCqMrsfjCY3iuNisi1R+4VcLEsyKIAB9NoqHxfDdPZNYXebzuXxej5MZ9eKb23x1dYu4QjDperGXuhrgs+k/aZAzxuJEbYH1V+Xa8PjX35QlVmhraJ4MJr07ayvUBSKswBuDet/ASA6U4VdAPvuAJ8rnhu9G3TJA7PKx/fuqKTQZ2icSTtuguUGmbG9+Y5xJ2lcldlpVWZXXSp+X1KV2aIqs+uqzNKqzE4l/' +
    'aL6CJClcbS+i7Hj98ntFdCWpMXXatKNwdppAOicVT5eK+zxSWzdWkDS48ZYoW+KdS7tvgv0tLkcQdkUvmdVmc2twxyqKrOiKrNpVWbnkv4maSzpxjhW77gbJ3fWORqQRPpaTYrxZggAHIprItBN19YBjnQi7VAA0/2VVE91/j30wvclVZmtqzKbu+7wf0j6h6Rv1rl6JMYf8kmLrxXLtSnG7wMAOFRhHQDAj9z53UE3b4bp7HSXDvC06SAddyvpvCqzqXWQNlRllldldinp' +
    'P1V3htemgeIXY+GTtPEiEa3/XTL9GQAABKKwDnCk8zcLYLd5UiwdlkNMqjJLur7GtwlVmd27zvDcOkvM' +
    '3IZlD9Y5PGtrHXDSwmu0YW4dAAC6hHN0gU4rrAMc670O8FUrKbrnQdLfqzILfZ47wkAXuLuv0YYY//0BAECcgj/C6tUC2J37G/I29IdaSkraOssXUAR30l6QtPAaMcxOWfZxhgkAvGWYzjgmB+ioGM5wfqsDfNlWiA6h+IWFGDuASZNPHtH638I6AAB0EEcJAWgMBfCTTfHLZjRolfueC/nMw5c0vQ44lsHR3DoAAHQQHWCg24LeCfrFAth1Vz62G8XUgyh+YWtuHaABSa' +
    'DP3ZY7ZpsAwIsS6wBHYCyJPlhbBzjGax3gyzZDGKP4RRcU1gEakAT63G2Jceo7APiQWAc4Ajc20QdB78PyWgGctprC1hVdGFhz34NBTyd5QdLEk7rj2U6aeO6WFdYBAKBrhunsTNIn6xxHoKECdNwPBfBgNEkVx+ByF9845xYdEltHsKl1wEkDz9m2h6rMYvv3BgAfptYBjkRTBei2xUsd4L50f+/U33OO0U2FdYAGJIE8Z9sofgHgmWE6O1f4R3BSACNqw3SWWGc4xio' +
    'f379UACdtBzFyxbpfdEmkHcEkkOdsW4z/1gBwMHf279w6x5HuVvmYsSVid2Yd4FjfFcBubV0fdn++jbTYQPh' +
    'urAN4lvh8Mtb/AkC05gp77a9E9xf9kFgHOMKt9OMa4KT9HCam1gGAV8R2Y8b3OuDE43NZuWH2CQDUhunsdJjOFpK+WGfxILaf4cBLQl4uey/1swC+rcqssA4BvKKwDtCAc4/PlXh8LisMkABA0jCdparPEw2987tRWAcAmuTesyHPxFtI/SyAp9YBgNdUZbaWtLTO4VnS0eeyQgEMoNeG6SwdprNC0j8V9mB623KVj9fWIYCGhb6B8EKSPmx+F9Haurcs6f4iALniuRsu' +
    'eSpaI7lGLZn+DKCPXOcoUT19Msb9ZubWAYAmud2fP1vnONJa2iqA5XeaYlddWwcAdpBL+modwiNfF8vE0/NYmlsHAICmueOMzlSPLROFP2jeBbN7ELvQ66iHVT7+vgOsfhTAXJzQeVWZLQajyYPC73Y+GowmiYfZF4mHKNa4BgHogtMjz/I81ffjxs1zxTBT5xA3TH9GzIbp7Frhz04sNp/0qQBm51WEJJd0YR3Co0THbw6SHJ3C1tKt8QYAa58k/WUdIiKhd8aAVw3T' +
    '2aWk36xzeFBsPtneBCv26SmFdQBgD7F1CpNj/nIk638L6wAAAO9uV/m4sA4BNMEVvzPrHJ4Um09+kqTBaHJmlaR' +
    'FsRUUiFthHcCzY2+wJT5CGJtbBwAAeDe1DgA0wU17jqX4vdus/5WeOsBnNllac8fUQ4TETde/sc7h02A0SY7468f83S64q8ps8f7DAAABofuL6AzTWTJMZwvFMe1547tG6GYNcOzrfxl4IkSFpC/WITxKdHhnO/GWwgYzUAAgPqGfiQo8GqazM9UzGmLag2Zjvv2bTQF82n6OVlEAI0S5pMw6hEfJIX+J9b8AgA76Y3tKJRAqd0b3peJqumxbPn+v9qUDXFgHAPZVldl6' +
    'MJosFf628xuHrgNOfIYw8FCVGR1gAIjHnVj7i0C5c7qTrY/Qmwzv+WGX9r50gDn+CKEqFE8BfOh5wKHfoKP4BYC4pKt8zNgSbTrb8+zuM32/x1Oiut6LZky5owe9MA778MIDo8PmMwhYrrg2IUi0/4yMxHuKdlEAA0A8Jkx9hoELxbk2t2nXL92s2uwCHfMZwA/WAYBDuW5pTN/DyT4Pdke0fWwkSXsK6wAAAC++rfLxD9MpAXTSg16Y/iw9FcAx4y4dQhdTB3Hfm21JE' +
    'yFadOOOtAIAhG0pdn0GQvJi91fqRwEMhK6wDuDTnucB7/PYLorp5gUA9NVSUsK6XyAYr3Z/JQpgIASxFVFJQ4/to' +
    'tj+7QCgbyh+gfBcvfWe/cmtsYvZ2joAcAw3hfbWOodHyS4PimD975LpzwAQNIpfIDy3q3w8f+sBP+n7LbJjtLYOAHgQUydx13XASZMhWjC3DgAAONiNKH6B0DxIunzvQUyBBsJQWAfwacd1wLs8pstiumkBAH3yxyofc9YvEJ6rVT5ev/cgCmAgAO4s6zvrHB4lnh7TVcuqzNbWIQAAe3mQ9I9VPma3ZyA8396b+rzRhwL43DoA4ElMHcU335cRrP8trAMAAPZyK+l8lY' +
    '9j+lkL9MVex5R9aDBIV5xaBwA8KST9Zh3Ck+TI/951c+sAAICdPKg+L3RqHQTAQR4k7bVkoQ8dYCAKVZnlqt/kMTgZjCZvdYGTtoI04M5NWQcAdNum6zu1DgLgIA+qN6tb7/OXPkhioAaEo5D0xTqEJ4lev/4k7cXwjulzANBtd6o3y+F6DYQtWeXjvWvZn3pwTuWuR64AIYjph3Xy0h+y/hcA0JAHSb+v8vEZxS8QvPEhxa/UjzXAQEwK6wAeJXv+eQge3FR1AEB3PEi' +
    '6Vr3WN/bGDxC7zZrf4tAn6MUa4B3PHAU6zx2ts7TO4clr64CTtoN4RPELAN3xIOl3SWerfDyl+AWCt1nzWxzzJJ' +
    'sO8J3CnnL4njPrAIBHuaRP1iE8SfTjOuCk/RjeUAADgL07SVNJOUUvEI2lpMtDpz1v23SA18c+UcdxFjBiElORlWz/hvW/AAAP5qt8PKf4BaJxowM3vHpJL6ZAK+yOEvAdd8TOnXUOT5J3fh+Smx5sKggAIUisAwDwZrLKx3ud8/ueTQEc+1FInwajyal1CMCjwjqAJ8/XASdWQTyIqTMPACE7sw4A4GhLSX9f5eNr30+8KYD70LVIrAMAHsVUbCVbn4e8XCGmfxMACNn' +
    'HYTqj8QGE6/dVPj73NeX5ub50gCUptQ4AeFRYB/AokSQ3SyPUzb2WTH8GgE4J+YYq0Fe3qru+0yZfpE8dYApgRMMVWzfWOTxJnv0aorl1AADAdxLrAAB2difpH6t87G2jq7d8kKSqzIrBaNL0a1k7GYwml1WZza2DAJ4Ukr5Yh/Bgsw44sQ5yBKY/AwjJUtLVjo+9lHTRXJTG0AEGuu9O0nSVj+dtvuiHrc9jPwtYqi/ic+MMgC+5pMw6hCeJwi2Al1WZra1DAMAe7lf5u' +
    'NjlgW4tbYgFcGIdAMCrTArfje1jkPqwDvizO2cUCJ4rupbWOTxJFe7638I6AAA0KNRlcifDdHZmHQLAd24k/bLKx' +
    '2dWxa/UvwJYkqbWAQCPCusAnny2DnCEuXUAAGhQqAWwRBcY6II7Sb9L+ps7z7cwzvNdAVxYhWjZxbNzR4GQsfbU1l1VZn25eQigh9rYkKZBiXUAoKfuJP2hekfns1U+nq7y8do406PHNcA92Qhr41pcFBEB9759kHRinaWnuAEBAN3FCSBAe5aqx0V512+c/fTs97GsJ3zP58FowkURsaAIs1NYBwCAFtxaBzjQyTCdMd4DmrFU3eX9h6T/XOXjc9fp7XTxK32/C7RUD+Z' +
    'C3YhmX/PBaHLmzlMFQlYozB06Q/dQlRk3HwCg21Jxoxg41q2kteo9oxZdWMd7jJcK4N8Mclg4UX1BTIxzAMfKJc2sQ/QQAyoAfVEo3M0K6QAD79vM8lg/+1is8nF0zcLvCuCqzPIerQOW6qnQ06rMptZBgENVZXY/GE1uFe7gJFQUwAD6IuQB8MkwnaWrfMw1GyH7Jr+nTtyHMFW5Kc87wFJ9PtOXtoMY+joYTdZVmc2tgwBHyEUB3LbCOgAAtCT0gfKluGmJsK1Dn3bcJ' +
    'c83wZL6eYGYDUaTS+sQwBEK6wA9c8P+AQB6JPQC+MswnZ1ZhwDQDRTATyiCESx3Fu2ddY4e6et1EkAPuTWAD9Y5' +
    'jjS1DgCgG34ogF1X48YgSxdQBCNkFGXt4WsNoG9C7wJf0AUGIL3cAZb6PbibDUaTqXUI4ACFdYCeWDL9GUAPhV4AS3SBAeiVAthtCBX6VJdjfB2MJsVgNDm1DmJhMJqcDkaTS/c1KKzzYDfuTNo+v2/bMrcOAAAGYiiAL4bpLLEOAcDWax1giUHeZ0nrwWjSi/PjtoreXNL/qT5Xll2Fw1NYB+iBPs+QAdBfMRTAkjQfprNeNjgA1N4qgK9bS9FdJ5L+6TqhZ9ZhmjAYTd' +
    'LBaDLXU9HbpyOwYkRx1qxlVWZr6xAA0LaIzgz9KJo8QK+9WgC7QV5fN8N67rOkfw1Gk3nohfB2p3cwmvxb0j8lXVjngjcUwM0qrAMAgKFb6wCefBmms7l1CAA23uoAS3SBn7vQUyF8bh1mV69Mb6bTGyG3OdPSOkfE5tYBAMBQYR3AowuKYKCfPrz1H6syKwajya1YC/rchaSLwWiyVH2TIO/arrCuQE8kXUr6ZBoGbcvFv3kT7tx5ywDQV7FdAy+G6excUrrKx2vrMADa' +
    '8WYB7Ewl/dVwjlB9Ut1NnbkbBbmkwmKQ7HasTlUXvYnqNS7op1zSV+sQEWJ6OYC+K6wDNOCTpH8N09k3SVMKYSB+7' +
    'xbAdIF39tl9aDCaSPU6mULSWtK6KrPC1wsNRpNE0qmk860PCl5IkqoyWwxGkzvxPeFbYR0AACyt8vH9MJ0tFecsowvVHeHHhsYhG3+5Y5Y2s/DyVT6ee8wIwINdOsASXeBDPBbE0mNRLH2/gcRC0ltTp89VF7pyv8b4AwfNKMTmZj49uHOWAaDvCsU9Hnkcvw3TmfQ0biteefxmrHamH288xzZlHIjCTgWw6wLfiI2TfPj8yueAT7kogH2i+AWAWiHpN+sQLfr87FcAgXtvF' +
    '+htV42lAOAV3Urv+HoCgKRVPuZ6CCBou06BVlVm68Fo8rvYXAcIBbM2/CmsA/hQldlU9ZIWADgGP192s7YOAOBH+3SAN4Onu2aiAPCssA4QiZuuHXMGAMboAu9mbR0AwI/2KoCdS98hADSCAYoffB0B4HtcFwEEa+8C2B3n84f/KAB8qspsLWlpnSMCDPQAYMsqH9+rngYNAMHZeQ3wM1PV55vFvA0+EINCvE+PsYxl+vP//td/TxXfHg6///znr1PrEEBP5WIdMIAAHTIFW' +
    'm5AeOk3CoAGzK0DBG5uHQAAOiqX9GAdAgD2dVABLElVmS0kTTxmAeCZe58yQDkc058B4AVuGjTXSADBObgA' +
    'lqSqzK4lffOUBUAzGKAcZunWUQMAXnZtHQAA9nVUAexciY12gC4rrAMEqrAOAABdtsrHC0m31jkAYB9HF8BuPXAiplkCXUUH+DBz6wAAEAC6wACC4qMDTBEMdJh7f3KHfj93bv00AOANq3ycS7qzzgEAu/JSAEuPm+2kvp4PgFd0gffD1wsAdje1DgAAu/JWAEtSVWaFpLHP5wTgBQXdfgrrAAAQilU+nouZRgAC4bUAlqSqzOaiCAY6xe1mzBS13TxUZcYNAwDYz9Q6AADsw' +
    'nsBLFEEAx1FUbcbvk4AsKdVPi4k3VjnAID3NFIASxTBQAcV1gECQQEMAIe5EhuiAui4xgpg6bEI/ru4GALm3LRe3ovvK6wDAECIVvl4LaZCA+i4Rgtg6XF36ESsPwS6oLAO0HE37tgoAMABVvn4WmyIBaDDGi+Apcci+FzSso3XA/Aqpve+ja8PABzvUsw4AtBRrRTAklSV2X1VZueS/mjrNQH8gALvbXx9AOBIbir0lXUOAHhJawXwRlVmV6o3x+LOINAyN72XmRgvWzL9GQ' +
    'D8cGcD973psbYOAOBHrRfA0uPmWEyJBmzQ5XzZ3DoAAMRklY+v1OP1wK4TDqBjTApgSarKbO2mRP9ulQHo' +
    'KQrgl/F1AQD/UtHwANAhZgXwRlVmU9VHJXFxBFrgNqVjV/bvLasyW1uHAIDYrPLxverTQBjnAegE8wJYqgfkrhs8EWuDgTYU1gE6prAOAACxoggG0CWdKIA3qjK7Vr02+Jt1FiByTPf93tw6AADEjCIYQFd0qgCWHtcGX0r6RT3eOKFD2BU3QlWZUQA/uXPTwgEADdoqgml0ADDTuQJ4oyqzoiqzRHUhzN3C9t1JGldllloHQWNurAN0BDcDAKAlq3x8v8rHl6qXvQFA6zpb' +
    'AG+4Qvhc9dnBdISbtyl8z9xxVYhXYR2gIwrrAADQN6t8fK16E1Q2ZQTQqs4XwBtVmc23OsIUwv4tReHbN3Q+pQemgwOAjVU+Xqje++UP6ywA+iOYAnhja2r031SvIWHX6ON8k/RLVWbnFL794o796fvyAopfADDkpkRfqe4G0+AA0LgP1gEO5Qbvl4PR5FT1IeuXkj5bZgrInaRrSTlnn/ZeIemTdQhDFMAA0AGuG5wM09mlpKmkj6aBAEQr2AJ4oyqze9VHmMwHo8mZno' +
    'rhPg/qX/KgerB/zY632DKX9Jt1CEOFdQAAwJNVPp5LmlMIA2hK8AXwNtfNvJZ0TTEsqe70Fqo7vXS68IOqzBaD' +
    '0eRB0ol1FgM37gYaAKBjtgrhVNKVmOUHwJOoCuBtz4rhU9XnzqXu15jvJt7qqeil04td5JIurEMY4KYQgH0U1gE8WlsH2NUqH+eS8mE6O1Pd1LhU3OM4AA2LtgDe5ro8ufuQ6w6fqy6GzxX2XcVNwbuQVNDRwgEogAHgHat8XCiuIjgoq3y8Vj0lejpMZ5sxXKqwx3AADPSiAH7OdYfX2hoAD0aTc9XF8Jnqi+qpujV1+kF1kfv4QYcXnhTWAQwsuVkEAGFyG2YtVM/00zC' +
    'dJXpqapyLDjGAN/SyAH6JKyZ/KEBMn4oAAAChSURBVChdt3j7Q6ovshu+7jze6WlKUuF+XUi6r8qseOHxgBdVmd0PRpNb9esu+tw6gIG14jtiZG0dAIC9l7rzrku8WQInNTN2AxAgCuB3bHWLd+LWG5/v8LzFwaG6Z674uohr6wAtu9TTDZ4+6N3siZ///HWufhb+obhSPViPDTMtYMJ1iaUDxydbBbS1GK8NbfwMXkj6pYXXacvaOkBM/h/yA5JRqb49bwAAAABJRU5ErkJggg==';
// @media screen and (orientation: landscape)
export var strMark = 'mark';
export var marks = {
    civitrip: 'Xrtt4wwqqeA69AAsdfNMe32wQER',
};



//////////////////
// WEBPACK FOOTER
// ./src/Theme.ts
// module id = 5
// module chunks = 0